import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';

/**
 * Skeleton component for SearchResults.
 * Matches the dimensions and layout of the SearchResults component.
 */
export const SearchResultsSkeleton: React.FC<{
  itemCount?: number;
}> = t0 => {
  const $ = _c(6);
  const {
    itemCount: t1
  } = t0;
  const itemCount = t1 === undefined ? 9 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton height={20} width={200} />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== itemCount) {
    t3 = <div className="flex flex-col gap-comfy-xl">{Array.from({
        length: itemCount
      }, _temp)}</div>;
    $[1] = itemCount;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex justify-center mt-comfy-lg"><div className="flex gap-snug-sm"><Skeleton height={48} width={48} borderRadius="0.5rem" /><Skeleton height={48} width={48} borderRadius="0.5rem" /><Skeleton height={48} width={48} borderRadius="0.5rem" /></div></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <section className="SearchResults component"><div className="SearchResults__container container"><div className="flex flex-col gap-comfy-xl">{t2}{t3}{t4}</div></div></section>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
function _temp(_, index) {
  return <div key={index} className="flex-1 flex flex-col gap-snug-sm"><Skeleton height={24} width="80%" /><Skeleton height={16} width="100%" /><Skeleton height={16} width="90%" /></div>;
}